<template>
    <div>
      <h1>Contas Bancárias</h1>
      <b-row>
        <b-col>
          <router-link :to="'./create/'">
            <b-button size="sm">{{ $t("geral.create") }}</b-button>
          </router-link>
          <b-button
            variant="danger"
            size="sm"
            class="ml-2"
            :disabled="!selectedRows.length"
            @click="deleteSelected"
          >
            🗑️
          </b-button>
        </b-col>
      </b-row>
  
      <b-row style="min-height: 500px; flex-grow: 1;">
        <b-col :class="themeClass">
          <ag-grid-vue
            :gridOptions="gridOptions"
            :columnDefs="columnDefs"
            :localeText="localeText"
            :rowData="rowData"
            :defaultColDef="defaultColDef"
            :domLayout="'autoHeight'"
            :pagination="true"
            rowHeight="40"
            :paginationPageSize="15"
            @rowClicked="onRowClicked"
            @selection-changed="onSelectionChanged"
          ></ag-grid-vue>
        </b-col>
      </b-row>
    </div>
  </template>
  
  <script>
  import { AgGridVue } from "ag-grid-vue";
  
  export default {
    components: {
      AgGridVue
    },
    computed: {
      themeClass() {
        return this.$store.state.darkmode
          ? "ag-theme-alpine-dark"
          : "ag-theme-alpine";
      }
    },
    data() {
      return {
        localeText: this.$t("AG_GRID_LOCALE"),
        gridOptions: {
          onGridReady: this.onGridReady,
          paginationPageSize: 15,
          rowSelection: "multiple"
        },
        columnDefs: [
          {
            headerName: "Conta",
            field: "accountName",
            sortable: false,
            filter: true,
            checkboxSelection: true,
            headerCheckboxSelection: true
          },
          {
            headerName: "Banco",
            field: "bank.name",
            sortable: false,
            filter: true,
          },
          {
            headerName: "Titular",
            field: "holderDocumentNumber",
            sortable: false,
            filter: true,
          },
          {
            headerName: "Saldo Inicial",
            field: "initialBalance",
            sortable: false,
            filter: true
          },
         
          {
            headerName: "Saldo Atual",
            field: "balance",
            sortable: false,
            filter: true
          },
          {
            headerName: "Status",
            field: "active",
            sortable: false,
            filter: true,
            cellRenderer: params => {
              return params.value == "1"
                ? '<span style="color: green;">✅</span>'
                : '<span style="color: red;">❌</span>';
            }
          }
        ],
        rowData: [],
        defaultColDef: {
          resizable: true,
          flex: 1
        },
        selectedRows: []
      };
    },
    methods: {
      onGridReady(params) {
        this.$apiScheduler
          .get("/bankaccount/all")
          .then(response => {
            this.rowData = response.data;
          })
          .catch(error => {
            if (error.response.status == 401) {
              this.$store.dispatch("logout").then(() => {
                this.$router.push("/login");
              });
            } else {
              callback([]);
            }
          });
  
        this.gridApi = params.api;
        this.gridColumnApi = params.columnApi;
      },
  
      onRowClicked(event) {
        const rowData = event.data;
        this.$router.push({
          name: "ServiceCrud",
          params: { rowData: JSON.stringify(rowData), edit: true }
        });
      },
      onSelectionChanged() {
        if (this.gridOptions.api) {
          this.selectedRows = this.gridOptions.api
            .getSelectedNodes()
            .map(node => node.data);
        }
      },
      deleteSelected() {
        const selectedIds = this.selectedRows.map(row => row.id);
        if (selectedIds.length === 0) return;
  
        if (!confirm("Tem certeza que deseja remover os produtos selecionados?"))
          return;
  
        this.$apiScheduler
          .post("/bankAccount/delete", selectedIds)
          .then(() => {
            this.rowData = this.rowData.filter(
              row => !selectedIds.includes(row.id)
            );
            this.gridOptions.api.setRowData(this.rowData);
            alert("Contas removidas com sucesso!");
          })
          .catch(err => {
            console.error(err);
            alert("Erro ao remover empresas.");
          });
      }
    }
  };
  </script>
  
  <style>
  /* MODO ESCURO */
  .ag-root,
  .ag-root-wrapper,
  .ag-row,
  .ag-cell,
  .ag-header-cell,
  .ag-header-cell-label {
    background-color: #1e1e2f !important;
    color: #ffffffb3 !important;
    font-family: "Poppins", sans-serif;
    font-size: 12px;
    border: none !important;
  }
  
  /* MODO CLARO */
  .ag-theme-alpine .ag-root,
  .ag-theme-alpine .ag-root-wrapper,
  .ag-theme-alpine .ag-row,
  .ag-theme-alpine .ag-cell,
  .ag-theme-alpine .ag-header-cell,
  .ag-theme-alpine .ag-header-cell-label {
    background-color: #f5f6fa !important;
    color: #191919 !important;
    font-family: "Poppins", sans-serif;
    font-size: 12px;
    border: none !important;
  }
  </style>
  